// src/shared/components/dashboard/StatusIndicator.tsx
// ────────────────────────────────────────────────────────────────────────────
// Pipeline/service status indicator — animated pulse dot + label.
//
// Unifies: ArchiverDashboard.PipelineIndicator, ArchiverCard header dot.
// ────────────────────────────────────────────────────────────────────────────
import React, { memo } from 'react';

export interface StatusIndicatorProps {
  /** Whether the service/pipeline is active */
  active: boolean;
  /** Label text — e.g. "Pipeline Active", "7d retention" */
  label?: string;
  /** Optional sublabel — e.g. "30d retention" */
  sub?: string;
}

function StatusIndicator({ active, label, sub }: StatusIndicatorProps) {
  return (
    <div className="flex items-center gap-2">
      <span
        className={`inline-block w-2 h-2 rounded-full ${
          active ? 'bg-emerald-500 animate-pulse' : 'bg-neutral-600'
        }`}
      />
      {label && (
        <span className="text-xs text-neutral-400">{label}</span>
      )}
      {sub && (
        <span className="text-[10px] font-mono text-neutral-600">{sub}</span>
      )}
    </div>
  );
}

export default memo(StatusIndicator);
